import { render, staticRenderFns } from "./ChooseSocialIdType.vue?vue&type=template&id=2d406741&"
import script from "./ChooseSocialIdType.vue?vue&type=script&lang=js&"
export * from "./ChooseSocialIdType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports